import * as yup from 'yup';

export const schema = () => {
  return yup.object().shape({
    social_reason: yup.string().min(3, 'Deve ter pelo menos 3 caracteres').required('Razão Social é obrigatório'),
    cnpj: yup
      .string()
      .transform((value) => value ? value.replace(/\D/g, '') : '')
      .min(14, 'CNPJ deve ter 14 dígitos')
      .required('CNPJ é obrigatório'),
    owner: yup.string().min(3, 'Deve ter pelo menos 3 caracteres').required('O responsável é obrigatório'),
    phone_ddd: yup
      .string()
      .transform((value) => value ? value.replace(/\D/g, '') : '')
      .min(2, 'DDD deve ter 2 dígitos')
      .required('DDD é obrigatório'),
    phone_number: yup
      .string()
      .transform((value) => value ? value.replace(/\D/g, '') : '')
      .min(8, 'Telefone deve ter pelo menos 8 dígitos')
      .required('Telefone é obrigatório'),
    // Manter phone como opcional para compatibilidade com dados antigos
    phone: yup.string().optional(),
    email: yup
      .string()
      .email('E-mail inválido')
      .required('E-mail é obrigatório'),
    state_subscribe: yup
      .string()
      .transform((value) => value ? value.replace(/\D/g, '') : '')
      .min(9, 'Inscrição estadual incompleta')
      .required('Inscrição estadual é obrigatória'),
    rntrc: yup
      .string()
      .transform((value) => value ? value.replace(/\D/g, '') : '')
      .length(8, 'RNTRC deve ter exatamente 8 dígitos')
      .required('RNTRC é obrigatório'),
    zipcode: yup
      .string()
      .transform((value) => value ? value.replace(/\D/g, '') : '')
      .min(8, 'CEP deve ter 8 dígitos')
      .required('CEP é obrigatório'),
    address: yup.string().required('Endereço é obrigatório'),
    number: yup.string().optional(), // Tornar opcional
    neighborhood: yup.string().required('Bairro é obrigatório'),
    city: yup.string().required('Cidade é obrigatória'),
    state: yup.string().required('Estado é obrigatório'),
    // Campos opcionais
    fantasy_name: yup.string().optional(),
    municipal_subscribe: yup.string().optional(),
    city_code: yup.string().optional(),
    complement: yup.string().optional(),
    taxpayer: yup.string().optional(),
    lat: yup.number().nullable().optional(),
    lng: yup.number().nullable().optional(),
  });
};
